import axios from 'axios';
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { authHeader } from '../helpers';
import { DaySets, DaySetsNewDashboard, formatDate } from '../helpers/Chart/utility';

import variables from '../scss/_variables.scss'

function MessageLastDays() {
  var result = [];
  for (var i = 0; i < 30; i++) {
    var d = new Date();
    d.setDate(d.getDate() - i);
    result.push(formatDate(d))
  }

  return result.reverse()
}

export function fetchCustomerCount() {
  return async dispatch => {
    dispatch({
      type: 'FETCH_CUSTOMER_COUNT',
      payload: await axios.get(`${process.env.REACT_APP_API_URL}/customers/count`, { headers: authHeader() })
    })
  }
}

export function fetchProductCount() {
  return async dispatch => {
    dispatch({
      type: 'FETCH_PRODUCT_COUNT',
      payload: await axios.get(`${process.env.REACT_APP_API_URL}/products/count`, { headers: authHeader() })
    })
  }
}

export function fetchBroadcast() {

  const broadcastTotal = []
  const broadcastSuccess = []
  const broadcastFail = []
  let broadcastTotalLast7Days = 0

  return async dispatch => {

    const broadcastReport = await axios.get(`${process.env.REACT_APP_API_URL}/broadcast-message/summary`, { headers: authHeader() })
    dispatch({
      type: 'FETCH_BROADCAST',
      payload: broadcastReport.data
    })

    MessageLastDays().forEach(v => {
      const broadcast = broadcastReport.data.find(value => {
        return v === value._id
      })
      broadcastTotal.push(broadcast !== undefined ? broadcast.total : 0)
      broadcastSuccess.push(broadcast !== undefined ? broadcast.successTotal : 0)
      broadcastFail.push(broadcast !== undefined ? broadcast.failTotal : 0)
      broadcastTotalLast7Days = broadcast !== undefined ? broadcastTotalLast7Days + broadcast.total : broadcastTotalLast7Days + 0
    })

    dispatch({
      type: 'BROADCAST_TOTAL',
      payload: broadcastTotalLast7Days.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    })

    dispatch({
      type: 'CHART_BROADCAST',
      payload: {
        labels: MessageLastDays(),
        datasets: [
          {
            label: 'Total',
            backgroundColor: variables.medium_blue,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: broadcastTotal,
          },
          {
            label: 'Success',
            backgroundColor: variables.green,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: broadcastSuccess,
          },
          {
            label: 'Fail',
            backgroundColor: variables.coral,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: broadcastFail,
          }
        ],
      }
    })
  }
}

export function fetchProductReport() {
  const productLabels = []
  const numOfCustomers = []
  const colors = []

  return async dispatch => {

    const productReport = await axios.get(`${process.env.REACT_APP_API_URL}/products/summary`, { headers: authHeader() })
    dispatch({
      type: 'FETCH_PRODUCT_REPORT',
      payload: productReport.data
    })

    Array.isArray(productReport.data) && productReport.data.forEach(value => {
      productLabels.push(value.name)
      numOfCustomers.push(value.numOfCustomers)

      let r = Math.floor(Math.random() * 255);
      let g = Math.floor(Math.random() * 255);
      let b = Math.floor(Math.random() * 255);
      colors.push("rgb(" + r + "," + g + "," + b + ", 1)")
    })

    dispatch({
      type: 'PRODUCT_PIE_DATA',
      payload: {
        labels: productLabels,
        datasets: [
          {
            data: numOfCustomers,
            backgroundColor: colors,

            hoverBorderColor: 'rgba(200, 200, 200, 1)',
          }],
      }
    })
  }
}

// export function fetchMaximumMessage() {
//   return async dispatch => {
//     const maximumMessage = await axios.get(`${process.env.REACT_APP_API_URL}/broadcast-message/maximum`, { headers: authHeader() })
//     dispatch({
//       type: 'FETCH_MAXIMUM_MESSAGE',
//       payload: maximumMessage.data
//     })
//   }
// }
export function fetchchartData(selectedYear, selectedMonthIndex) {
  return async dispatch => {
    const NativeDate =
      (typeof window !== "undefined" && window.Date) ||
      (typeof global !== "undefined" && global.Date) ||
      Date;

    const now = new Date();

    const year = selectedYear ?? now.getFullYear();
    const monthIndex = selectedMonthIndex ?? now.getMonth();

    const startDate = `${year}${String(monthIndex + 1).padStart(2, "0")}01`;

    const isCurrentMonth = year === now.getFullYear() && monthIndex === now.getMonth();
    const lastDayOfMonth = new Date(year, monthIndex + 1, 0).getDate();
    const endDate = `${year}${String(monthIndex + 1).padStart(2, '0')}${String(lastDayOfMonth).padStart(2, '0')}`;
    const endDay = isCurrentMonth ? now.getDate() : new NativeDate(year, monthIndex + 1, 0).getDate();

    const startDateForDashboard = isCurrentMonth
      ? `${year}${String(monthIndex + 1).padStart(2, "0")}${String(endDay).padStart(2, "0")}`
      : `${year}${String(monthIndex + 1).padStart(2, "0")}01`;

    const endDateForDashboard = `${year}${String(monthIndex + 1).padStart(2, "0")}${String(endDay).padStart(2, "0")}`;

    const getSafe = v => +v || 0;
    const formatNumber = v => (+v || 0).toLocaleString("en-US");

    try {
      dispatch({ type: "FETCH_ACTIVITY_TOP_LOADING", payload: true });

      const [dailyReport, activity6KeyAndCode] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/customers/dailyReport`, { headers: authHeader(), params: { startDate, endDate }, }),
        axios.get(`${process.env.REACT_APP_API_URL}/activitylogs/activity6keyandabuddycode`, { headers: authHeader() }),
      ]);

      dispatch({ type: "FETCH_EXCEL_DATA", payload: dailyReport?.data?.dashboardByMonth, });

      const all_BMI = formatNumber(getSafe(dailyReport?.data?.dashboardCompleteBMIS?.complete_bmi_users));

      let mainABO = 0, mainMember = 0, mainPublic = 0, mainTotal = 0;

      const all_abo = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.abo_complete));
      const all_member = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.member_complete));
      const all_pub = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.public_complete));
      const all_emp = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.employee_complete));

      const all_abo_block = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.abo_block));
      const all_member_block = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.member_block));
      const all_pub_block = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.public_block));
      const all_emp_block = formatNumber(getSafe(dailyReport?.data?.dashboardByAll?.employee_block));

      const all_Total = formatNumber(
        getSafe(dailyReport?.data?.dashboardByAll?.abo_complete) +
        getSafe(dailyReport?.data?.dashboardByAll?.member_complete) +
        getSafe(dailyReport?.data?.dashboardByAll?.public_complete)
      );

      const all_Total_block = formatNumber(
        getSafe(dailyReport?.data?.dashboardByAll?.abo_block) +
        getSafe(dailyReport?.data?.dashboardByAll?.member_block) +
        getSafe(dailyReport?.data?.dashboardByAll?.public_block)
      );

      const days = DaySetsNewDashboard(year, monthIndex);
      const labels = days.map(d => d.label);

      days.forEach(day => {
        const data = dailyReport?.data?.dashboardByMonth?.find(v => v._id === day.id);
        const abo = data?.abo_complete || 0;
        const member = data?.member_complete || 0;
        const pub = data?.public_complete || 0;

        mainABO += abo;
        mainMember += member;
        mainPublic += pub;
        mainTotal += abo + member + pub;
      });

      const mainABO_Percent = mainTotal ? ((mainABO / mainTotal) * 100).toFixed(2) : "0.00";
      const mainMember_Percent = mainTotal ? ((mainMember / mainTotal) * 100).toFixed(2) : "0.00";
      const mainPublic_Percent = mainTotal ? ((mainPublic / mainTotal) * 100).toFixed(2) : "0.00";
      const mainTotal_Percent = mainTotal ? "100.00" : "0.00";

      const mainABO_fmt = formatNumber(mainABO);
      const mainMember_fmt = formatNumber(mainMember);
      const mainPublic_fmt = formatNumber(mainPublic);
      const mainTotal_fmt = formatNumber(mainTotal);

      const { sixKeyCount = 0, roomIdCount = 0, activateCodeCount = 0, SkinAccDist = 0, SkinAcc = 0, StressAccDist = 0, StressAcc = 0 } = activity6KeyAndCode?.data || {};
      const sixKeys = formatNumber(sixKeyCount);
      const roomIdAll = formatNumber(roomIdCount);
      const abuddyCode = formatNumber(activateCodeCount);
      const skinAccessDist = formatNumber(SkinAccDist);
      const skinAccess = formatNumber(SkinAcc);
      const stressAccessDist = formatNumber(StressAccDist);
      const stressAccess = formatNumber(StressAcc);

      dispatch({
        type: "FETCH_CHART_DATA",
        payload: {
          labels,
          datasets: [
            {
              label: "ABO",
              backgroundColor: variables.medium_blue,
              borderColor: getStyle("--info"),
              pointHoverBackgroundColor: "#fff",
              borderWidth: 1,
              data: days.map(day => {
                const data = dailyReport?.data?.dashboardByMonth?.find(v => v._id === day.id);
                return data?.abo_complete || 0;
              }),
            },
            {
              label: "Member",
              backgroundColor: "#149191",
              borderColor: getStyle("--info"),
              pointHoverBackgroundColor: "#fff",
              borderWidth: 1,
              data: days.map(day => {
                const data = dailyReport?.data?.dashboardByMonth?.find(v => v._id === day.id);
                return data?.member_complete || 0;
              }),
            },
            {
              label: "Public",
              backgroundColor: variables.coral,
              borderColor: getStyle("--info"),
              pointHoverBackgroundColor: "#fff",
              borderWidth: 1,
              data: days.map(day => {
                const data = dailyReport?.data?.dashboardByMonth?.find(v => v._id === day.id);
                return data?.public_complete || 0;
              }),
            },
          ],
          meta: {
            startDateForDashboard,
            endDateForDashboard,

            mainABO: mainABO_fmt,
            mainMember: mainMember_fmt,
            mainPublic: mainPublic_fmt,
            mainTotal: mainTotal_fmt,
            mainABO_Percent,
            mainMember_Percent,
            mainPublic_Percent,
            mainTotal_Percent,

            all_abo,
            all_member,
            all_pub,
            all_abo_block,
            all_member_block,
            all_pub_block,
            all_Total,
            all_Total_block,
            all_emp,
            all_emp_block,

            roomIdAll,
            abuddyCode,
            all_BMI,
            sixKeys,
            skinAccessDist,
            skinAccess,
            stressAccessDist,
            stressAccess,
          },
        },
      });

      axios
        .get(`${process.env.REACT_APP_API_URL}/activitylogs/activitytop`, { headers: authHeader(), params: { startDate, endDate }, })
        .then(response => {
          dispatch({ type: "FETCH_ACTIVITY_TOP", payload: response?.data || [], });
        })
        .catch(error => {
          dispatch({ type: "FETCH_ACTIVITY_TOP_ERROR", payload: error?.message || String(error), });
        })
        .finally(() => {
          dispatch({ type: "FETCH_ACTIVITY_TOP_LOADING", payload: false });
        });

    } catch (err) {
      dispatch({ type: "FETCH_CHART_DATA_ERROR", payload: err?.message || String(err), });
      dispatch({ type: "FETCH_ACTIVITY_TOP_LOADING", payload: false });
      throw err;
    }
  };
}



